import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const state = {
  tabbarShow: true,
  errorShow: false,
  globalBg:'#F7F7F7',
  serviceObjects:[],
  serviceWays:[],
  serviceTypes:[],
  serviceDepts:[],
  serviceParams:{
    target: undefined,
    publisher: undefined,
    handleWay: undefined,
    type: undefined,
    related: "false",
    keyword:undefined
  },
  matterObjects:[],
  matterNatures:[],
  matterModels:[],
  matterDepts:[],
  matterParams:{

  },
  // font值选择保存 获取session中的sizeNum,如果没有就设置为0
  sizeNum: localStorage.getItem('sizeNum') || 0
};

import mutations from "@/store/mutations";
import actions from "@/store/actions";
import getters from "@/store/getters";


export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})
